import { useEffect, useState } from 'react';

/**
 * Scale that fits a fixed-height into the viewport, capped
 * so the composition never grows past its designed size.
 * Short screens shrink the whole layout proportionally instead of crushing its internal spacing.
 * Can't be done in CSS: a scale() factor must be unitless, and
 * CSS has no way to divide a length by a length, so the viewport
 * is measured instead.
 */
export function useFitToHeight(designHeight: number, max = 1): number {
  const [scale, setScale] = useState(max);

  useEffect(() => {
    const measure = () => {
      const height = window.visualViewport?.height ?? window.innerHeight;
      setScale(Math.min(max, height / designHeight));
    };

    measure();
    window.addEventListener('resize', measure);
    window.visualViewport?.addEventListener('resize', measure);
    return () => {
      window.removeEventListener('resize', measure);
      window.visualViewport?.removeEventListener('resize', measure);
    };
  }, [designHeight, max]);

  return scale;
}
